import { configureStore } from '@reduxjs/toolkit';

import authReducer, { syncRefreshedSession } from '@/features/auth/authSlice';
import usersReducer from '@/features/users/usersSlice';
import homeownersReducer from '@/features/homeowners/homeownersSlice';
import propertiesReducer from '@/features/properties/propertiesSlice';
import propertySchemasReducer from '@/features/property-schemas/schemasSlice';
import propertyTemplates from '@/features/property-templates/propertyTemplatesSlice';
import propertyLocations from '@/features/locations/locationsSlice';
import propertySystems from '@/features/systems/systemsSlice';
import utilities from '@/features/utilities/utilitiesSlice';
import propertyDraft from '@/features/property-draft/propertyDraftSlice';
import media from '@/features/media/mediaSlice';
import organizations from '@/features/organizations/organizationsSlice';
import roles from '@/features/roles/rolesSlice';
import appState from '@/features/app-state/appStateSlice';
import invitations from '@/features/invitations/invitationsSlice';
import support from '@/features/support/supportSlice';
import businessUsersPool from '@/features/business-users-pool/businessUsersPoolSlice';
import homeownerUsersPool from '@/features/homeowner-users-pool/homeownerUsersPoolSlice';
import propertyDocuments from '@/features/property-documents/propertyDocumentsSlice';
import propertyMembers from '@/features/property-members/propertyMembersSlice';
import propertyExpenses from '@/features/property-expenses/propertyExpensesSlice';
import passwordReset from '@/features/password-reset/passwordResetSlice';
import recovery from '@/features/recovery/recoverySlice';

import { settingsReducer, subscriptionReducer } from '@/features/admin';
import { dynamicConfig } from './config';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    users: usersReducer,
    homeowners: homeownersReducer,
    properties: propertiesReducer,
    settings: settingsReducer,
    propertySchemas: propertySchemasReducer,
    subscriptions: subscriptionReducer,
    propertyTemplates: propertyTemplates,
    propertyLocations: propertyLocations,
    propertySystems: propertySystems,
    utilities: utilities,
    propertyDraft: propertyDraft,
    media: media,
    organizations: organizations,
    roles: roles,
    appState: appState,
    invitations: invitations,
    support: support,
    businessUsersPool: businessUsersPool,
    homeownerUsersPool,
    propertyDocuments: propertyDocuments,
    propertyMembers: propertyMembers,
    propertyExpenses: propertyExpenses,
    passwordReset,
    recovery,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: { extraArgument: { config: dynamicConfig } },
      serializableCheck: false,
    }),
});

dynamicConfig.tokenService.subscribe((session) => {
  store.dispatch(syncRefreshedSession(session));
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
